import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: resolve => {
        require(["@/views/index"], resolve);
      }
    },
    {
      path: "/iframe",
      name: "iframe",
      component: resolve => {
        require(["@/views/iframe"], resolve);
      }
    },
    {
      path: "/free_support",
      meta: {
        name: "免费设计"
      },
      name: "免费设计",
      component: resolve => {
        require(["@/views/h5/free_support"], resolve);
      }
    },
    {
      path: "/amall_userRegister",
      meta: {
        name: "A猫营销端用户协议"
      },
      name: "A猫营销端用户协议",
      component: resolve => {
        require(["@/views/amall_userRegister"], resolve);
      }
    },
    {
      path: "/amallEngineeringRegister",
      meta: {
        name: "A猫商城"
      },
      name: "A猫商城",
      component: resolve => {
        require(["@/views/amallEngineeringRegister"], resolve);
      }
    },
    {
      path: "/amallAallRegister",
      meta: {
        name: "A猫工程端"
      },
      name: "A猫工程端",
      component: resolve => {
        require(["@/views/amallAallRegister"], resolve);
      }
    },
    {
      path: "/specialList",
      meta: {
        name: "特殊任务列表"
      },
      name: "特殊任务列表",
      component: resolve => {
        require(["@/views/specialList"], resolve);
      }
    },
    {
      path: "/userIndex",
      meta: {
        name: "智慧舒适家中央空调"
      },
      name: "智慧舒适家中央空调",
      component: resolve => {
        require(["@/views/userPc/userIndex"], resolve);
      }
    },
    {
      path: "/floorHeating",
      meta: {
        name: "智慧舒适家地暖"
      },
      name: "智慧舒适家地暖",
      component: resolve => {
        require(["@/views/userPc/floorHeating"], resolve);
      }
    },
    {
      path: "/operating",
      meta: {
        name: "代运营"
      },
      name: "智慧舒适家代运营",
      component: resolve => {
        require(["@/views/userPc/operating"], resolve);
      }
    },
    {
      path: "/industryHeadlines",
      meta: {
        name: "行业头条"
      },
      name: "智慧舒适家代运营",
      component: resolve => {
        require(["@/views/operationsCenter/industryHeadlines"], resolve);
      }
    },
    {
      path: "/learningMaterials",
      meta: {
        name: "学习资料详情"
      },
      name: "学习资料详情",
      component: resolve => {
        require(["@/views/learning/learningMaterials"], resolve);
      }
    },
    {
      path: "/onlineLearning",
      meta: {
        name: "在线学习"
      },
      name: "在线学习",
      component: resolve => {
        require(["@/views/learning/onlineLearning"], resolve);
      }
    },
    {
      path: "/onlineLearningDetail",
      meta: {
        name: "在线学习详情"
      },
      name: "在线学习详情",
      component: resolve => {
        require(["@/views/learning/onlineLearningDetail"], resolve);
      }
    },
    {
      path: "/marketingRegister",
      meta: {
        name: "A猫营销端隐私协议"
      },
      name: "A猫营销端隐私协议",
      component: resolve => {
        require(["@/views/marketingRegister"], resolve);
      }
    },
    {
      path: "/partnerRegistration",
      meta: {
        name: "合伙人注册协议"
      },
      name: "合伙人注册协议",
      component: resolve => {
        require(["@/views/partnerRegistration"], resolve);
      }
    },
    {
      path: "/textH5",
      meta: {
        name: "测试H5"
      },
      name: "智慧舒适家代运营",
      component: resolve => {
        require(["@/views/textH5"], resolve);
      }
    },
    // 营销端H5代理人注册
    {
      path: "/agentH5",
      meta: {
        name: "营销端代理人注册H5"
      },
      name: "智慧舒适家代运营",
      component: resolve => {
        require(["@/views/marketingH5/agentH5"], resolve);
      }
    },
    // 营销端合伙人注册H5
    {
      path: "/partnerH5",
      meta: {
        name: "营销端合伙人注册H5"
      },
      name: "智慧舒适家代运营",
      component: resolve => {
        require(["@/views/marketingH5/partnerH5"], resolve);
      }
    },

    //  //工程师评级资格
    //  {
    //   path: "/InvestigationResearch",
    //   meta: {
    //     name: "工程师评级资格"
    //   },
    //   name: "工程师评级资格",
    //   component: resolve => {
    //     require(["@/views/marketingH5/InvestigationResearch"], resolve);
    //   }
    // },
    {
      path: "/todaySentence",
      meta: {
        name: "金句分享"
      },
      name: "金句分享",
      component: resolve => {
        require(["@/views/marketingH5/todaySentence"], resolve);
      }
    },
    {
      path: "/marketingSideDownApp",
      meta: {
        name: "A猫营销端下载"
      },
      name: "A猫营销端下载",
      component: resolve => {
        require(["@/views/downLoadApp/marketingSideDownApp.vue"], resolve);
      }
    },
    {
      path: "/engineeringEndDownApp",
      meta: {
        name: "A猫工程端下载"
      },
      name: "A端工程端下载",
      component: resolve => {
        require(["@/views/downLoadApp/engineeringEndDownApp.vue"], resolve);
      }
    },
    {
      path: "/mallDownApp",
      meta: {
        name: "A猫商城下载"
      },
      name: "A猫商城下载",
      component: resolve => {
        require(["@/views/downLoadApp/mallDownApp.vue"], resolve);
      }
    },
    {
      path: "/specialTask",
      meta: {
        name: "特殊任务"
      },
      name: "特殊任务列表",
      component: resolve => {
        require(["@/views/marketingH5/specialTask"], resolve);
      }
    },
    {
      path: "/studyData",
      meta: {
        name: "学习资料"
      },
      name: "学习资料",
      component: resolve => {
        require(["@/views/marketingH5/studyData"], resolve);
      }
    },
    {
      path: "/textIndex",
      meta: {
        name: "学习资料"
      },
      name: "学习资料",
      component: resolve => {
        require(["@/views/text/index"], resolve);
      }
    },
    {
      path: "/upgradePartner",
      meta: {
        name: "升级合伙人"
      },
      name: "升级合伙人",
      component: resolve => {
        require(["@/views/upgradePartner/index"], resolve);
      }
    },
    {
      path: "/testSecondarySharing",
      meta: {
        name: "测试二次分享"
      },
      name: "测试二次分享",
      component: resolve => {
        require(["@/views/testSecondarySharing/index"], resolve);
      }
    },
    {
      path: "/testUrlScheme",
      meta: {
        name: "测试urlScheme"
      },
      name: "测试urlScheme",
      component: resolve => {
        require(["@/views/testUrlScheme/index"], resolve);
      }
    },
    {
      path: "/GYFTest",
      meta: {
        name: "GYFTest"
      },
      name: "GYFTest",
      component: resolve => {
        require(["@/views/GYF_test/index"], resolve);
      }
    },
  ]
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js